'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopoverArrow = function (_Component) {
  _inherits(PopoverArrow, _Component);

  function PopoverArrow() {
    _classCallCheck(this, PopoverArrow);

    return _possibleConstructorReturn(this, (PopoverArrow.__proto__ || Object.getPrototypeOf(PopoverArrow)).apply(this, arguments));
  }

  _createClass(PopoverArrow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          position = _props.position,
          style = _props.style,
          shouldHaveBorder = _props.shouldHaveBorder;
      var borderColor = style.borderColor,
          background = style.background;


      if (!shouldHaveBorder) borderColor = 'transparent';

      var borderPos = position.charAt(0).toUpperCase() + position.substr(1);

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_styles2.default.arrowContainer, _styles2.default[position]) },
        _react2.default.createElement(
          'span',
          { className: _styles2.default.arrow, style: _defineProperty({}, 'border' + borderPos + 'Color', borderColor) },
          _react2.default.createElement('span', { className: (0, _classnames2.default)(_styles2.default.inner, _styles2.default.arrow, _defineProperty({}, '' + _styles2.default.noBorder, !shouldHaveBorder)),
            style: _defineProperty({}, 'border' + borderPos + 'Color', background) })
        )
      );
    }
  }]);

  return PopoverArrow;
}(_react.Component);

PopoverArrow.propTypes = {
  position: _propTypes2.default.oneOf(['top', 'bottom', 'left', 'right']),
  shouldHaveBorder: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    background: _propTypes2.default.string.isRequired,
    borderColor: _propTypes2.default.string.isRequired
  })
};
PopoverArrow.defaultProps = {
  position: 'top',
  style: {
    borderColor: '#ccc',
    background: 'white'
  }
};
exports.default = PopoverArrow;